module.exports = __webpack_public_path__ + "static/img/onlineshowheaderbg.15c024e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onlineshowheaderbg.png
// module id = Apfz
// module chunks = 8